import { FileInfo } from "src/app/shared/model/generic/fileInfo";

export class ContratoAnexo {
  public contratoId: number;
  public descritivo: string;
  public observacoes: string;
  public file: FileInfo;
}
